import { Cell } from 'modules/admin/Common';
import CommonAssetAdmin from 'modules/admin/CommonAssetAdmin';
import { asset$ } from 'modules/asset/asset$';
import React from 'react';
import { connect } from 'rxbeach/react';
import { combineLatest, map } from 'rxjs';
import PageEditor from './PageEditor';

const columns = [
  {
    header: 'Tittel',
    property: 'label',
    search: true,
    render: (e: any) => <Cell>{e.label}</Cell>
  },
  {
    header: 'Type',
    property: 'type',
    search: true,
    render: (e: any) => <Cell>{e.type}</Cell>
  },
  {
    header: 'Tab',
    property: 'tab',
    search: true,
    render: (e: any) => <Cell>{e.tab}</Cell>
  },
  {
    header: 'Rekkefølge',
    property: 'order',
    render: (e: any) => <Cell>{e.order}</Cell>
  },
];

const viewModel$ = combineLatest([asset$]).pipe(
  map(([{ byId }]) => ({
    byId,
    pages: Object.values(byId).filter(e => e.type !== 'news').sort(
      (a, b) => b.createdAt - a.createdAt
    ),
  }))
);

const NewsAdmin = ({ pages, byId }: any) => {
  return (
    <CommonAssetAdmin
      data={pages}
      byId={byId}
      columns={columns}
      Editor={PageEditor}
    />
  )
}

export default connect(NewsAdmin, viewModel$);
